"use client";

import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, motion } from "motion/react";
import { useAIChatContext } from "./contexts";
interface AIChatSuggestionsProps {
  suggestions: string[];
  isLoading?: boolean;
  suggestionKey?: number;
  className?: string;
}
export function AIChatSuggestionsV2(t0) {
  const $ = _c(12);
  const {
    suggestions,
    isLoading: t1,
    suggestionKey: t2,
    className
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const suggestionKey = t2 === undefined ? 0 : t2;
  const {
    actions
  } = useAIChatContext();
  if (suggestions.length === 0 && !isLoading) {
    return null;
  }
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      opacity: 0,
      y: -8
    };
    t4 = {
      opacity: 1,
      y: 0
    };
    t5 = {
      opacity: 0,
      y: -8
    };
    t6 = {
      duration: 0.2,
      ease: "easeOut"
    };
    $[0] = t3;
    $[1] = t4;
    $[2] = t5;
    $[3] = t6;
  } else {
    t3 = $[0];
    t4 = $[1];
    t5 = $[2];
    t6 = $[3];
  }
  let t7;
  if ($[4] !== actions || $[5] !== isLoading || $[6] !== suggestions) {
    t7 = isLoading ? <div className="grid grid-cols-1 gap-1.5 sm:grid-cols-2">{[1, 2, 3, 4].map(_temp)}</div> : <div className="grid grid-cols-1 gap-1.5 sm:grid-cols-2">{suggestions.map((suggestion, idx_0) => <motion.button key={idx_0} type="button" initial={{
        opacity: 0,
        x: -4
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.15,
        delay: idx_0 * 0.05
      }} onClick={() => actions.sendMessage(suggestion)} className="rounded-md border border-accent-foreground/20 bg-background px-2.5 py-1.5 text-left text-caption text-foreground-secondary transition-colors hover:border-accent-foreground hover:bg-accent hover:text-accent-foreground">{suggestion}</motion.button>)}</div>;
    $[4] = actions;
    $[5] = isLoading;
    $[6] = suggestions;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== className || $[9] !== suggestionKey || $[10] !== t7) {
    t8 = <AnimatePresence><motion.div key={suggestionKey} initial={t3} animate={t4} exit={t5} transition={t6} className={className}>{t7}</motion.div></AnimatePresence>;
    $[8] = className;
    $[9] = suggestionKey;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
}
function _temp(idx) {
  return <div key={idx} className="h-8 animate-pulse rounded-md bg-accent-foreground/10" />;
}